import { z } from "zod";
import { ZDateish } from "../foundationSchema";
export const MIGRATION_LOCKS_COLLECTION_NAME = "migration_locks";
/** No expiry: an abandoned lock must be inspected before another writer can start. */
export const ZMigrationLockMongoDocument = z.object({
    _id: z.literal("global"),
    runId: z.string().uuid(),
    migrationId: z.string().min(1),
    actor: z.string().min(1),
    acquiredAt: ZDateish,
});
